// Pro API - Media Operations
import { request } from "../base";
import type { Media } from "./types";

export const mediaApi = {
	async listByRoom(proId: string, roomId: number) {
		return request<Media[]>(`/api/pro/${proId}/rooms/${roomId}/media`);
	},

	async create(
		proId: string,
		roomId: number,
		data: {
			mediaType: "image" | "video";
			filename: string;
			storageKey: string;
			thumbnailKey?: string;
			width?: number;
			height?: number;
			fileSize?: number;
			durationSeconds?: number;
			caption?: string;
			altText?: string;
		},
	) {
		return request<Media>(`/api/pro/${proId}/rooms/${roomId}/media`, {
			method: "POST",
			body: data,
		});
	},

	async createBulk(
		proId: string,
		roomId: number,
		items: Array<{
			mediaType: "image" | "video";
			filename: string;
			storageKey: string;
			thumbnailKey?: string;
			width?: number;
			height?: number;
			fileSize?: number;
			durationSeconds?: number;
			caption?: string;
			altText?: string;
		}>,
	) {
		return request<Media[]>(
			`/api/pro/${proId}/rooms/${roomId}/media/bulk`,
			{
				method: "POST",
				body: { items },
			},
		);
	},

	async update(
		proId: string,
		mediaId: number,
		data: { caption?: string; altText?: string },
	) {
		return request<Media>(`/api/pro/${proId}/media/${mediaId}`, {
			method: "PUT",
			body: data,
		});
	},

	async delete(proId: string, mediaId: number) {
		return request(`/api/pro/${proId}/media/${mediaId}`, {
			method: "DELETE",
		});
	},

	async move(proId: string, mediaId: number, newRoomId: number) {
		return request<Media>(`/api/pro/${proId}/media/${mediaId}/move`, {
			method: "POST",
			body: { roomId: newRoomId },
		});
	},

	async reorder(proId: string, roomId: number, mediaIds: number[]) {
		return request(`/api/pro/${proId}/rooms/${roomId}/media/reorder`, {
			method: "POST",
			body: { mediaIds },
		});
	},

	async setRoomCover(proId: string, roomId: number, mediaId: number) {
		return request(`/api/pro/${proId}/rooms/${roomId}/cover`, {
			method: "POST",
			body: { mediaId },
		});
	},
};
